module.exports = __webpack_public_path__ + "media/images/library-dd192c453475eb458dc9c3d8eccc38b2.jpg";